import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createSameDayCancellation } from "@/http/sameDayCancellationApi";
import type { CreateSameDayCancellationData } from "@/@types/sameDayCancellation.types";
import { getSameDayCancellationsQueryKey } from "@/utils/queryKeys";

interface CreateSameDayCancellationParams {
  phone: string;
  data: CreateSameDayCancellationData;
  clubId?: string;
}

export const useCreateSameDayCancellationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ phone, data, clubId }: CreateSameDayCancellationParams) => {
      const response = await createSameDayCancellation(phone, data, clubId);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getSameDayCancellationsQueryKey(),
      });
    },
  });
};
